/**
 * Retention 5.7 — reply feedback reasons + anti-nag (mirrors Express).
 */

export const OLLIE_REPLY_FEEDBACK_REASONS = Object.freeze([
  Object.freeze({ id: 'incorrect_answer', label: 'Incorrect answer' }),
  Object.freeze({ id: 'didnt_understand', label: "Didn't understand" }),
  Object.freeze({
    id: 'couldnt_complete',
    label: "Couldn't complete the task",
  }),
  Object.freeze({ id: 'missing_information', label: 'Missing information' }),
  Object.freeze({ id: 'other', label: 'Other' }),
])

/**
 * Ask for a rating at most once per conversation, on the latest completed
 * assistant reply — never on every bubble.
 */
export function shouldAskOllieReplyFeedback({
  messages = [],
  messageId = null,
} = {}) {
  if (!messageId) return false
  const list = Array.isArray(messages) ? messages : []
  const target = list.find(row => String(row?.id) === String(messageId))
  if (!target || target.role !== 'assistant') return false
  if (target.timedOut || target.unanswered) return false
  if (target.feedback?.rating) return false
  if (String(target.id || '').startsWith('pending-')) return false

  const alreadyRated = list.some(
    row => row?.role === 'assistant' && row?.feedback?.rating,
  )
  if (alreadyRated) return false

  const eligible = list.filter(
    row =>
      row?.role === 'assistant' &&
      row?.id &&
      !String(row.id).startsWith('pending-') &&
      !row.timedOut &&
      String(row.content || '').trim(),
  )
  if (!eligible.length) return false
  const latest = eligible[eligible.length - 1]
  return String(latest.id) === String(messageId)
}
